import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as mapUtils from '../assets/map-utils'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      application: window.APPLICATION,
      loading: true,
      parcel: null,
      features: [],
      conceptFilters: {}
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      datasetUrl (state) {
        return state.application.configuration &&
          state.application.configuration.datasets &&
          state.application.configuration.datasets[0] &&
          state.application.configuration.datasets[0].href
      },
      schema (state) {
        return state.application.configuration &&
          state.application.configuration.datasets &&
          state.application.configuration.datasets[0] &&
          state.application.configuration.datasets[0].schema
      },
      parcelleIdField (state, getters) {
        return getters.schema && getters.schema.find(field => field['x-refersTo'] === 'http://dbpedia.org/ontology/codeLandRegistry')
      },
      linkField (state, getters) {
        return getters.schema && getters.schema.find(f => f['x-refersTo'] === 'https://schema.org/WebPage')
      },
      attachmentField (state, getters) {
        return getters.schema && getters.schema.find(f => f['x-refersTo'] === 'http://schema.org/DigitalDocument')
      },
      config (state) { return state.application.configuration },
      defaultColor (state) {
        return state.application.configuration.defaultColor || '#828282'
      },
      dateField (state, getters) {
        return getters.schema && getters.schema.find(field => field['x-refersTo'] === 'http://schema.org/Date')
      },
      legend (state, getters) {
        if (!getters.schema) return []
        if (getters.config && getters.config.colorField) {
          const colorField = getters.schema.find(f => f.key === getters.config.colorField)
          if (getters.config.colors) return getters.config.colors.map(c => [c.value, c.color])
          else return colorField.enum.map((val, i) => [val, mapUtils.colors[i]])
        } else {
          return [['*', getters.defaultColor]]
        }
      }
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      }
    },
    actions: {
      async init ({ state, commit, dispatch, getters }) {
        if (getters.datasetUrl) {
          try {
            const qParams = new URLSearchParams(window.location.search)
            if (qParams.get('selected')) {
              const ids = qParams.get('selected').split(',')
              const select = [].concat(getters.config.tooltip)
              if (getters.linkField) select.push(getters.linkField.key)
              if (getters.config.colorField) select.push(getters.config.colorField)
              const params = {
                size: 1000,
                select: select.join(','),
                ...state.conceptFilters,
                qs: `${getters.parcelleIdField.key}:(${ids.join(' OR ')})`
              }
              if (getters.dateField) params.sort = getters.dateField.key

              const { data } = await axios.get(`${getters.datasetUrl}/lines`, { params })
              commit('setAny', { features: data.results })
            }
          } catch (err) {
            dispatch('setError', (err.response && err.response.data) || err.message)
          }
        }
      },
      async setError ({ state }, error) {
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      }
    }
  })
}
